// @flow

import { CONFERENCE_JOINED } from '../base/conference/actionTypes';
import { MiddlewareRegistry } from '../base/redux';
import './subscriber';

declare var APP: Object;

MiddlewareRegistry.register(({ dispatch, getState }) => next => action => {

    switch (action.type) {
    case CONFERENCE_JOINED: {

        break;
    }
    }

    return next(action);
});
